import { render, staticRenderFns } from "./MinistriesHealth.vue?vue&type=template&id=c065d2aa&"
import script from "./MinistriesHealth.vue?vue&type=script&lang=js&"
export * from "./MinistriesHealth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports